module.exports = "/img/../img/tobias-reich-jolBvWtbQrE-unsplash.f93c07bed2ab99f8b25b7c4267f1d556.jpg";